import { service } from '@ember/service';
import {
  getSingleValueForTasField,
  setSingleValueForTasField,
  type FieldName,
} from 'tio-common/utils/tuition-assistance/fields';
import Route from '@ember/routing/route';
import type { IntlService } from 'ember-intl';
import type RouterService from '@ember/routing/router';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';
import type TasApplicationModel from 'tio-common/models/tas-application';

export default class AuthenticatedTasApplicationsTypeFourNewRoute extends Route {
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  includes = [
    'tas-courses',
    'tas-courses.tas-assets.attachments',
    'tas-program-instance',
    'tas-program-instance.tas-program-template.tas-groups',
    'tas-program-instance.tas-program-template.conditions.public-assets',
    'tas-program-instance.tas-program-template.tas-field-options',
    'tas-program-instance.employee.person',
    'tas-program-instance.employee.tas-participant',
    'tas-program-instance.employee.company',
    'tas-program-instance.employee.pcs-card-holders',
    'tas-assets.attachments',
    'tas-assistances',
    'tags',
  ];

  queryParams = {
    date: {
      refreshModel: false,
    },
  };

  saveDate(date: string, application: TasApplicationModel, lockStatus: string) {
    const field: FieldName =
      lockStatus === 'COURSE_END_DATE' ? 'COURSES_END_DATE' : 'COURSES_BEGIN_DATE';

    const fieldValue = getSingleValueForTasField(field, application.fields);

    if (fieldValue) {
      return false;
    }
    setSingleValueForTasField(field, date, application.fields);
    return true;
  }

  async model({ tas_application_id, date = '' }: { tas_application_id: string; date?: string }) {
    const application = await this.store.findRecord<TasApplicationModel>(
      'tas-application',
      tas_application_id,
      {
        include: this.includes.join(','),
        reload: true,
      }
    );

    if (date) {
      const programTemplate = application.tasProgramInstance.tasProgramTemplate;
      const lockStatus: string = getSingleValueForTasField(
        'LOCK_EMPLOYEE_STATUS_BASED_ON',
        programTemplate.fields
      );
      const saved: boolean = this.saveDate(date, application, lockStatus);

      if (saved) {
        try {
          await application.save();
        } catch (error) {
          console.error('Failed to save application, instance, or course:', error);
          application.rollbackAttributes();
        }
      }
    }

    return {
      application: application,
      programInstance: application.tasProgramInstance,
    };
  }
}
